module.exports = __webpack_public_path__ + "img/first.39d16c88.png";